import { get_token } from "@/router";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import MenuSideBar from '@/components/MenuSidebar/MenuSidebar.vue'
import StickyNav from "@/components/BottomNavbar/StickyNavbar.vue";
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';

export default {
    components: {
        HomeNavBar,
        MenuSideBar,
        StickyNav,
        InactivityModal
      },
  data() {
    return ({
      users: [],
      userSearch: "",
      loading: true,
    });
  },
  computed: {
    filteredUsers() {
      if (!this.userSearch) return this.users;
      return this.users.filter(user =>
        `${user.first_name} ${user.last_name}`.toLowerCase().includes(this.userSearch.toLowerCase())
      );
    },
  },
  mounted() {
    this.fetchUsers();
  },
  methods: {
    fetchUsers() {
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/retrieve_users/`,
          type: "GET",
          headers: {
            Authorization: `Token ${get_token()}`,
            "Content-Type": "application/json",
          },
          success: (response) => {
            if (response.status === "success" && response.data && response.data.users_list) {
              // Sort alphabetically by first name
              this.users = response.data.users_list.sort((a, b) =>
                a.first_name.toLowerCase().localeCompare(b.first_name.toLowerCase())
              );
            }
            this.loading = false;
          },
          error: (error) => {
            console.error("Error fetching users:", error);
            this.loading = false;
          },
        });
      },
    
      view_profile(userId) {
        // Directly navigate via href like in your business example
        window.location.href = `/profile?user_id=${userId}`;
      }
  },
};